module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAPpJREFUKFOFkMErRFEYxX/nzUxZ62XlD5hQsqWUkshKymrsZmcnxUbZSdPspKxMKexQFKVmxXaW81jbjZ1JEe/ojhmpSe8s7u2793fO9/WJrka2PRrBVpoyD8SCRBFXH2/sPVX1EjCFY3LXy+kXZ0C+Z/69xXMuz+z9ph41V/GYIho2eQWrfyJs+FMn769MaOXAxzalvsT+h7LKNbecEmfCoqb109AwWxJ32rl0E1PMwi32Vb11RbCRBX+aBR3WHeciGhLD/xkMF+VpLXX2fPLgYqHAOXTH6a4v/AWw1WZ1bUbtDhx0VPfA0CClSEyFLqlJbK4Xx3XTY74BZNlS38R0hyQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeroCode/blue-dian.png
// module id = 8jCe
// module chunks = 0